import React, { useState, useEffect } from 'react'
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js"
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import PropTypes from 'prop-types';

const PaymentForm = ({ accountId }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    let result = await axios.post("createintent2/",{ amount: 1000, currency: 'usd', accountId });

    const { error, paymentIntent } = await stripe.confirmCardPayment(result.data.clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    });

    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      console.log('Payment successful', paymentIntent);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement />
      <button type="submit" disabled={!stripe || loading}>
        Pay
      </button>
      {error && <div>{error}</div>}
    </form>
  );
};

PaymentForm.propTypes = {
  accountId: PropTypes.any,
};

const Payment2 = () => {
    const [stripePromise, setStripePromise] = useState(null);
    const [clientAccountId, setClientAccountId] = useState(null);

    
    useEffect(() => {
      async function fetchData() {
        let result = await axios.post("getpaymentinfo2/", {isStripe: true});
        setStripePromise(loadStripe(result.data.result))
      }
      fetchData()
    }, [])
    useEffect(() => {
      async function fetchData() {
        let result = await axios.post("createconnectedcccount2/", {isStripe: true});
        setClientAccountId(result.data.accountId)
      }
      fetchData()
    }, [])

    return (
        <div>
            <div className="page-wrapper">
                <div className="content col-6 mx-auto my-4">
                    
                  <Elements stripe={stripePromise}>
                    {clientAccountId && <PaymentForm accountId={clientAccountId} />}
                  </Elements>
                </div>
            </div>
        </div>
    )
}

export default Payment2
